import { HttpClient } from '@angular/common/http';
import { emailValidator, numericValidator, timeValidator } from '@core';
import { TranslateLoader } from '@ngx-translate/core';
import {
  CheckboxTypeComponent,
  InputTypeComponent,
  InputWithHelperTypeComponent,
  LabelTypeComponent,
  PhoneTypeComponent,
  RadiobuttonTypeComponent,
  SectionTitleComponent,
  SelectTypeComponent,
  ShipmentIdentifierTableTypeComponent,
  SubtitleTypeComponent,
  TextareaTypeComponent,
  TimepickerTypeComponent,
  ToggleTypeComponent

} from '@shared';
import { HttpLoaderFactory } from 'src/app/app.httpLoaderFactory';
// import { ToggleComponent } from 'src/app/shared/components/form-controls/toggle/toggle.component';

export const FORMLY_CUSTOM_CONFIG = {
  loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpClient],
  },
  types: [
    {
      name: 'ups-subtitle',
      component: SubtitleTypeComponent,
    },
    {
      name: 'ups-label',
      component: LabelTypeComponent,
    },
    {
      name: 'ups-input',
      component: InputTypeComponent,
      extends: 'input',
    },
    {
      name: 'ups-input-email',
      component: InputTypeComponent,
      extends: 'ups-input',
      defaultOptions: {
        validators: {
          email: emailValidator,
        },
      },
    },
    {
      name: 'ups-input-numeric',
      component: InputTypeComponent,
      extends: 'ups-input',
      defaultOptions: {
        validators: {
          numeric: numericValidator,
        },
      },
    },
    {
      name: 'ups-input-phone',
      component: PhoneTypeComponent,
      extends: 'ups-input',
    },
    {
      name: 'ups-select',
      component: SelectTypeComponent,
      extends: 'select',
    },
    {
      name: 'ups-textarea',
      component: TextareaTypeComponent,
      extends: 'textarea',
    },
    {
      name: 'ups-checkbox',
      component: CheckboxTypeComponent,
    },
    {
      name: 'ups-toggle',
      component: ToggleTypeComponent,
    },
    {
      name: 'ups-timepicker',
      component: TimepickerTypeComponent,
      extends: 'ups-input',
      defaultOptions: {
        validators: {
          time: timeValidator,
        },
      },
    },
    {
      name: 'ups-input-with-helper',
      component: InputWithHelperTypeComponent,
    },
    {
      name: 'ups-shipment-identifier-table',
      component: ShipmentIdentifierTableTypeComponent,
    },
    {
      name: 'ups-radio-group',
      component: RadiobuttonTypeComponent,
    },
    {
      name: 'ups-section-title',
      component: SectionTitleComponent,
    },
  ],
};
